<!-- Collapsed mode: show only avatar initial of selected workspace -->
<div *ngIf="collapsed && selectedWorkspace" class="ws-selector-collapsed" [pTooltip]="selectedWorkspace.name" tooltipPosition="right">
  <button
    type="button"
    class="ws-avatar"
    [attr.aria-label]="'Cambiar equipo, actual: ' + selectedWorkspace.name"
    (click)="op.toggle($event)"
  >
    {{ getInitial(selectedWorkspace.name) }}
  </button>
</div>

<!-- Expanded mode: full dropdown -->
<div *ngIf="!collapsed" class="ws-selector-expanded">
  <p-dropdown
    [options]="workspaces"
    [(ngModel)]="selectedWorkspaceId"
    optionValue="id"
    (onChange)="onWorkspaceChange($event.value)"
    [disabled]="loading"
    placeholder="Seleccionar equipo"
    styleClass="ws-dropdown"
    [style]="{ width: '100%' }"
    appendTo="body"
  >
    <ng-template let-ws pTemplate="selectedItem">
      <div class="ws-item">
        <span class="ws-name">{{ ws.name }}</span>
        <span *ngIf="isPersonalWorkspace(ws)" class="ws-badge">(Mío)</span>
      </div>
    </ng-template>
    <ng-template let-ws pTemplate="item">
      <div class="ws-item">
        <span class="ws-name">{{ ws.name }}</span>
        <span *ngIf="isPersonalWorkspace(ws)" class="ws-badge">(Mío)</span>
      </div>
    </ng-template>
  </p-dropdown>
</div>

<!-- Overlay panel for collapsed mode -->
<p-overlayPanel #op>
  <div class="ws-overlay-list">
    <button
      type="button"
      *ngFor="let ws of workspaces"
      class="ws-overlay-item"
      [class.ws-overlay-item--active]="ws.id === selectedWorkspaceId"
      [attr.aria-label]="'Cambiar a equipo ' + ws.name"
      (click)="onWorkspaceChange(ws.id); op.hide()"
    >
      <div class="ws-avatar ws-avatar--sm" aria-hidden="true">{{ getInitial(ws.name) }}</div>
      <span class="ws-name">{{ ws.name }}</span>
      <span *ngIf="isPersonalWorkspace(ws)" class="ws-badge">(Mío)</span>
    </button>
  </div>
</p-overlayPanel>
